import { withDebugId } from './withDebugId';
export var createTheme = function createTheme(themeInput, debugId) {
  return withDebugId(themeInput, debugId);
};
//# sourceMappingURL=createTheme.js.map
